import type { UploadRequestOption } from 'rc-upload/lib/interface';
import commonApi from 'apis/common';

const toFile = (file: UploadRequestOption['file']): File => {
  if (file instanceof File) return file;
  if (typeof file === 'string') {
    throw new Error('不支持的文件类型');
  }
  return new File([file], 'upload', { type: file.type });
};

export type AntdUploadRequestOptions = {
  recycleOrderId?: number | string;
  productId?: number;
  isPrivate?: boolean;
  compress?: boolean;
};

/** Ant Design Upload customRequest，走 Node 上传；onSuccess 保持 Java 接口的 { data: { url } } 形状 */
export const createAntdUploadRequest = (
  uploadOptions?: AntdUploadRequestOptions,
) => {
  return async (options: UploadRequestOption) => {
    const { file, onSuccess, onError, onProgress } = options;

    try {
      const result = await commonApi.uploadFile(
        toFile(file),
        uploadOptions?.isPrivate ?? false,
        {
          compress: uploadOptions?.compress,
          productId: uploadOptions?.productId,
          recycleOrderId: uploadOptions?.recycleOrderId,
          onProgress: ({ loaded, total }) => {
            onProgress?.({ percent: total ? (loaded / total) * 100 : 0 });
          },
        },
      );
      onSuccess?.({ data: { url: result.url } });
    } catch (error) {
      onError?.(error as Error);
    }
  };
};

export const antdUploadRequest = createAntdUploadRequest();
